import { t, Trans } from '@lingui/macro';

import {
  MenuItem,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import { TableEmpty } from 'components';
import { getEmployeeType } from 'constants/employee';
import { useSearch } from 'hooks';
import { useActiveLocale } from 'hooks/useActiveLocale';
import { DateTime } from 'luxon';
import { useQuery } from 'react-query';
import { enterpriseSetupService } from 'services';
import { WorkingType } from 'types/EnterpriseSetup';

const EmployeeListStopWorking = ({
  enterpriseId,
  workingType,
}: {
  enterpriseId?: number;
  workingType: WorkingType;
}) => {
  const [dataSearch, onSearchChange] = useSearch({ id: enterpriseId, workingType });
  const userLocale = useActiveLocale();

  const { data } = useQuery(
    ['enterpriseSetupService.fetchEmployees', dataSearch],
    () => enterpriseSetupService.fetchEmployees(dataSearch),
    { keepPreviousData: true },
  );
  const { data: items = [], paginate } = data ?? {};

  return (
    <div>
      <div className='flex items-center justify-end'>
        <div className='flex space-x-3'>
          <TextField select defaultValue={1}>
            <MenuItem value={1}>
              <Trans>Employee Name</Trans>
            </MenuItem>
            <MenuItem value={2}>
              <Trans>ID No.</Trans>
            </MenuItem>
            <MenuItem value={3}>
              <Trans>Type</Trans>
            </MenuItem>
            <MenuItem value={4}>
              <Trans>Level</Trans>
            </MenuItem>
          </TextField>
          <TextField placeholder={t`Search...`} />
        </div>
      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Trans>Employee Name</Trans>
              </TableCell>
              <TableCell>
                <Trans>ID No.</Trans>
              </TableCell>
              <TableCell>
                <Trans>Type</Trans>
              </TableCell>
              <TableCell>
                <Trans>Level</Trans>
              </TableCell>
              <TableCell>
                <Trans>Phone</Trans>
              </TableCell>
              <TableCell>
                <Trans>Type of Labor Contract</Trans>
              </TableCell>
              <TableCell>
                <Trans>Last working day</Trans>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <TableRow key={item.employeeId}>
                <TableCell>{item.employee.name}</TableCell>
                <TableCell>{item.employee.ercNumber}</TableCell>
                <TableCell>{getEmployeeType(item.employeeType)}</TableCell>
                <TableCell>
                  {userLocale === 'vi-VN' ? item.employeeLevel?.viContent : item.employeeLevel?.enContent}
                </TableCell>
                <TableCell>{item.employee.phone}</TableCell>
                <TableCell>{userLocale === 'vi-VN' ? item.laborTerm?.viContent : item.laborTerm?.enContent}</TableCell>
                <TableCell>
                  {item.stopWorkingDate ? DateTime.fromISO(item.stopWorkingDate).toFormat('dd/MM/yyyy') : ''}
                </TableCell>
              </TableRow>
            ))}
            <TableEmpty data={items} />
          </TableBody>
        </Table>
      </TableContainer>

      <div className='flex justify-center'>
        <Pagination
          page={paginate?.page ?? 1}
          count={paginate?.totalPage}
          onChange={(event, value) => onSearchChange({ page: value })}
        />
      </div>
    </div>
  );
};

export default EmployeeListStopWorking;
